import { createSlice } from "@reduxjs/toolkit";

export interface IMasterCatalogPayload {
  crops: string[];
  seasons: string[];
  locations: string[];
  trials: string[];
  analysisStates: string[];
  [key: string]: any; // Allow dynamic properties for catalog-specific filters (e.g., isDemo, plotType, etc.)
}

export interface MasterCatalogState {
  payload: IMasterCatalogPayload | null;
}

const initialState: MasterCatalogState = {
  payload: null,
};

export const MasterCatalogSlice = createSlice({
  name: "MasterCatalog",
  initialState,
  reducers: {
    updateMasterCatalogPayload: (state, action) => {
      state.payload = action.payload;
    },
    resetMasterCatalogPayload: (state) => {
      state.payload = null;
    },
  },
});

export const { updateMasterCatalogPayload, resetMasterCatalogPayload } = MasterCatalogSlice.actions;

export default MasterCatalogSlice.reducer;
